/* unplugin-vue-components disabled */import { render } from "./ViewTable.vue?vue&type=template&id=5f58ea7b"
import script from "./ViewTable.vue?vue&type=script&lang=js"
export * from "./ViewTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\RedFlag\\Desktop\\code\\qms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__